<template>
  <div>
    <div class="text-center">
      <CountDownIcon
        v-if="verificationResult === 'error_timeout' && isDynamicFormStep"
        class="my-6"
        :value="100 / resendSMSTimeDefaultValue"
      />
    </div>
    <div
      v-html="
        `${$t(`phoneVerification.error.${verificationResult}.perex`)}${
          $vuetify.breakpoint.smAndDown ? '' : ` (${$t('ulekareContacts.hours')})`
        }.`
      "
    />
    <div v-if="verificationResult === 'error_block' && $vuetify.breakpoint.smAndDown" class="mt-2">
      <div
        class="border rounded-lg border_box pa-4 pr-7 cursor-pointer"
        @click="redirectTo(`tel:${linkerizePhone()}`)"
      >
        <v-row align="center">
          <v-col cols="auto">
            <v-img contain width="48" height="48" :src="$asset('img/icons/phone.svg')" />
          </v-col>
          <v-col>
            <strong class="box_title">{{
              $t(`phoneVerification.error.${verificationResult}.callUs`)
            }}</strong>
            <div class="text-body-small grey-darken-1--text">
              <span v-html="`${$t('ulekareContacts.phone')} ${$t('ulekareContacts.hours')}`" />
            </div>
          </v-col>
          <v-col cols="auto arrow_box">
            <v-icon class="rotate-270">$dropSmall</v-icon>
          </v-col>
        </v-row>
      </div>

      <div
        class="border rounded-lg border_box pa-4 pr-7 cursor-pointer mt-2"
        @click="redirectTo(`mailto:${$t('ulekareContacts.email')}`)"
      >
        <v-row align="center">
          <v-col cols="auto">
            <v-img contain width="48" height="48" :src="$asset('img/icons/mail.svg')" />
          </v-col>
          <v-col>
            <strong class="box_title">{{
              $t(`phoneVerification.error.${verificationResult}.writeUs`)
            }}</strong>
            <div class="text-body-small grey-darken-1--text">
              {{ $t('ulekareContacts.email') }}
            </div>
          </v-col>
          <v-col cols="auto arrow_box">
            <v-icon class="rotate-270">$dropSmall</v-icon>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import countdown from '@/mixins/countdown';
import { mapActions, mapGetters } from 'vuex';
import phoneLink from '@/mixins/phoneLink';
import phoneVerification from '@/mixins/phoneVerification';

export default {
  name: 'PhoneVerificationError',
  mixins: [countdown, phoneLink, phoneVerification],
  computed: {
    ...mapGetters({
      verificationResult: 'profile/phoneVerification/verificationResult'
    })
  },
  methods: {
    ...mapActions({
      setDialogTitle: 'profile/phoneVerification/setDialogTitle',
      setDialogLeftHeaderIcon: 'profile/phoneVerification/setDialogLeftHeaderIcon',
      setDialogButtons: 'profile/phoneVerification/setDialogButtons'
    }),

    countdownFinalFunction() {
      this.$emit('resendSms');
    },
    redirectTo(link) {
      window.location.href = link;
    },
    setDialogProps() {
      this.setDialogTitle(this.$t(`phoneVerification.error.${this.verificationResult}.title`));
      if (!this.isDynamicFormStep) {
        this.setDialogLeftHeaderIcon(
          this.verificationResult === 'error_block' ? 'icons/person-sad.svg' : null
        );
      }

      let buttons = [];
      if (this.verificationResult === 'error_block' && !this.$vuetify.breakpoint.smAndDown) {
        buttons = [
          {
            props: {
              color: 'tetrary'
            },
            events: {
              click: () => {
                this.redirectTo(`mailto:${this.$t('ulekareContacts.email')}`);
              }
            },
            text: this.$t('ulekareContacts.email')
          },
          {
            props: {
              loading: this.loading,
              color: 'primary'
            },
            events: {
              click: () => {
                this.redirectTo(`tel:${this.linkerizePhone()}`);
              }
            },
            text: this.$t('ulekareContacts.phone')
          }
        ];
      }

      this.setDialogButtons(buttons);
    }
  },
  watch: {
    verificationResult() {
      this.setDialogProps();
    },
    countdown(newValue) {
      this.$eventHub.$emit('phoneVerificationErrorCountdownUpdate', newValue);
    }
  },
  beforeMount() {
    if (this.verificationResult === 'error_timeout') {
      this.countdown = this.resendSMSTimeDefaultValue;
    }
  },
  mounted() {
    this.setDialogProps();
  }
};
</script>

<style lang="scss" scoped>
.border_box {
  width: 100%;
  box-shadow: 0 8px 10px -5px rgba($black, 0.05);

  &:hover,
  &:focus,
  &:active {
    box-shadow: none;
  }
}

.arrow_box {
  display: contents;
}

.box_title {
  margin-bottom: 2px;
}

.buttons {
  width: 100%;

  .inner_box {
    flex: 0 0 50%;
  }
}
</style>
